import React, { useEffect, useRef } from "react";

const Cursor = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const pos = useRef({ mx: 0, my: 0, rx: 0, ry: 0 });

  useEffect(() => {
    const move = (e) => {
      pos.current.mx = e.clientX;
      pos.current.my = e.clientY;
    };
    document.addEventListener("mousemove", move);

    const tick = () => {
      const p = pos.current;
      p.rx += (p.mx - p.rx) * 0.12;
      p.ry += (p.my - p.ry) * 0.12;
      if (dotRef.current) {
        dotRef.current.style.left = p.mx - 4 + "px";
        dotRef.current.style.top = p.my - 4 + "px";
      }
      if (ringRef.current) {
        ringRef.current.style.left = p.rx - 14 + "px";
        ringRef.current.style.top = p.ry - 14 + "px";
      }
      requestAnimationFrame(tick);
    };
    const raf = requestAnimationFrame(tick);

    const expand = () => {
      if (!ringRef.current) return;
      ringRef.current.style.width = "44px";
      ringRef.current.style.height = "44px";
      ringRef.current.style.borderColor = "rgba(192,132,252,0.7)";
    };
    const shrink = () => {
      if (!ringRef.current) return;
      ringRef.current.style.width = "28px";
      ringRef.current.style.height = "28px";
      ringRef.current.style.borderColor = "rgba(192,132,252,0.4)";
    };
    const targets = document.querySelectorAll("a, button, [data-hover]");
    targets.forEach((t) => {
      t.addEventListener("mouseenter", expand);
      t.addEventListener("mouseleave", shrink);
    });

    return () => {
      document.removeEventListener("mousemove", move);
      cancelAnimationFrame(raf);
      targets.forEach((t) => {
        t.removeEventListener("mouseenter", expand);
        t.removeEventListener("mouseleave", shrink);
      });
    };
  }, []);

  return (
    <>
      <div ref={dotRef} style={styles.dot} />
      <div ref={ringRef} style={styles.ring} />
    </>
  );
};

const styles = {
  dot: {
    position: "fixed",
    width: 8,
    height: 8,
    background: "var(--accent)",
    borderRadius: "50%",
    pointerEvents: "none",
    zIndex: 9999,
    mixBlendMode: "screen",
    transition: "opacity 0.2s",
  },
  ring: {
    position: "fixed",
    width: 28,
    height: 28,
    border: "1px solid rgba(192,132,252,0.4)",
    borderRadius: "50%",
    pointerEvents: "none",
    zIndex: 9998,
    transition: "width 0.2s, height 0.2s, border-color 0.2s",
  },
};

export default Cursor;
